import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconOtros(props) {
    return (
        <svg
            width={247}
            height={246}
            viewBox="0 0 247 246"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            d="M123.12 245.94C55.32 245.94.16 190.77.16 122.97.16 55.16 55.32 0 123.12 0c67.81 0 122.97 55.16 122.97 122.97 0 67.8-55.16 122.97-122.97 122.97zm0-239.07c-64 0-116.09 52.08-116.09 116.09 0 64.02 52.09 116.09 116.09 116.09 64.02 0 116.11-52.08 116.11-116.09S187.14 6.87 123.12 6.87z"
            fill="#000"
            />
            <path
            d="M185.63 38.74c-1.16-10.66 6.57-20.23 17.21-21.39 10.66-1.16 20.22 6.54 21.38 17.2 1.16 10.64-6.53 20.23-17.19 21.38-10.64 1.16-20.24-6.55-21.4-17.19z"
            fill="#000"
            />
            <path
            d="M194.54 37.77c-.63-5.75 3.51-10.88 9.27-11.51 5.76-.63 10.89 3.5 11.51 9.25.62 5.73-3.5 10.88-9.26 11.51-5.75.63-10.9-3.52-11.52-9.25z"
            fill="#FFDD00"
            />
            <path
            d="M122.91 141.99c8.48.08 15.21-6.46 15.28-14.86.08-8.48-6.46-15.2-14.86-15.28-8.48-.08-15.2 6.46-15.28 14.86-.07 8.48 6.47 15.2 14.86 15.28zm-52.97 0c8.45.01 15.16-6.72 15.12-15.15-.05-8.29-6.62-14.92-14.87-14.99-8.43-.07-15.31 6.6-15.4 14.94-.09 8.3 6.78 15.19 15.15 15.2zm106.36 0c8.37-.01 15.24-6.9 15.16-15.19-.09-8.35-6.96-15.02-15.39-14.95-8.25.07-14.82 6.69-14.87 14.98-.06 8.44 6.65 15.17 15.1 15.16z"
            stroke="#000"
            strokeWidth={7}
            strokeMiterlimit={10}
            />
            <path
            d="M122.91 141.99c-8.4-.08-14.93-6.8-14.86-15.28.07-8.4 6.8-14.93 15.28-14.86 8.4.07 14.94 6.8 14.86 15.28-.07 8.4-6.79 14.94-15.28 14.86zM69.94 141.99c-8.37-.01-15.24-6.91-15.15-15.2.09-8.34 6.97-15.02 15.4-14.94 8.24.07 14.82 6.7 14.87 14.99.05 8.43-6.67 15.17-15.12 15.15zM176.3 141.99c-8.45.01-15.16-6.72-15.11-15.16.05-8.29 6.62-14.92 14.87-14.98 8.43-.07 15.3 6.61 15.39 14.95.09 8.3-6.78 15.18-15.15 15.19z"
            stroke="#000"
            strokeWidth={7}
            strokeMiterlimit={10}
            />
        </svg>
    )
}

export default SvgIconOtros;